import React from "react";

const ReferenceNumber = ({ partnerInfo, searchedBy, janioTrackingNo }) => {
  const { partnerName, etn, config } = partnerInfo;
  const trackerUrl = config.trackerUrl(etn);

  if (searchedBy) {
    // User searched by ETN — show Janio TN (plain)
    return (
      <div className="partner-reference">
        <p className="tracking-title">Janio Tracking Number</p>
        <p className="tracking-ref-value">{janioTrackingNo}</p>
      </div>
    );
  }

  // User searched by Janio TN — show ETN linked to partner tracker
  return (
    <div className="partner-reference">
      <p className="tracking-title">Reference Number</p>
      <div className="tracking-ref-row">
        <span className="partner-badge" style={{ backgroundColor: config.badgeColor }}>{partnerName.toUpperCase()}</span>
        <a
          href={trackerUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="tracking-ref-value tracking-ref-link"
        >
          {etn}
        </a>
      </div>
    </div>
  );
};

export default ReferenceNumber;
